export default {
  path: "reward",
  component: () => import("./Layout"),
  children: [
    // 重大人才工程
    {
      path: "channel",
      component: () => import("./Channel"),
      meta: { title: "重大人才工程", depth: 1, keepAlive: true }
    },
    // 申报指南
    {
      path: "guide",
      component: () => import("./Guide"),
      meta: { title: "申报指南", depth: 2, keepAlive: true }
    },
    {
      path: "declaration",
      component: () => import("./Declaration"),
      meta: { title: "申报书等材料下载", depth: 2, keepAlive: true }
    },
    {
      path: "batch",
      component: () => import("./Batch"),
      meta: { title: "选择批次", keepAlive: true }
    },
    // 办理进度
    {
      path: "progress",
      component: () => import("./Progress"),
      meta: { title: "办理进度", depth: 2, keepAlive: true, needLogin: true }
    },
    // 申报流程
    {
      path: "apply",
      children: [
        // 奖补表单
        {
          path: "form",
          component: () => import("./Apply/Form"),
          meta: {
            title: "奖补申报",
            depth: 3,
            keepAlive: true,
            needLogin: true
          }
        }
      ]
    }
  ]
}
